// extracted by mini-css-extract-plugin
export var connectionButton = "_ax-1";
export var rightPanel = "_ax-3";
export var stepDescription = "_ax-2";
export var stepIcon = "_ax-0";